// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.4.5_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_wm7ee5ic4mofrhisudwon4qpq4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.4.5_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_wm7ee5ic4mofrhisudwon4qpq4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resize-container {
  position: absolute;
  /* todo: better z index */
  z-index: 10;
  /* todo: is this needed */
  background: transparent;
}

.resize-line {
  position: absolute;
  /* todo smarter z index */
  z-index: -1;
  pointer-events: none;
  /* a normal exit animation curve- at this point the exit animation is */
  /* immediately responsive so we don't need a bespoke curve */
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  /* todo: better var? */
  border: 1px solid var(--color-gray-100);
}

/* start really fast because we start super hidden initially behind the panel, otherwise feels like an unintended animation delay */
.resize-container:hover ~ .resize-line {
  transition: transform 0.2s cubic-bezier(0.05, 0.9, 0.2, 1); /* Fast start for animate in */
}

.resize-container.right,
.resize-container.left {
  top: 0;
  height: 100%;
  width: 25px;
  cursor: ew-resize;
}

/* todo: don't hard code all these values/use vars */

.resize-container.bottom,
.resize-container.top {
  left: 0;
  width: 100%;
  height: 25px;
  cursor: ns-resize;
}

.resize-container.top {
  top: -12px;
}
.resize-container.bottom {
  bottom: -12px;
}
.resize-container.left {
  left: -12px;
}
.resize-container.right {
  right: -12px;
}

.resize-container.top-left,
.resize-container.top-right,
.resize-container.bottom-left,
.resize-container.bottom-right {
  width: 32px;
  height: 32px;
  z-index: 15;
}

.resize-container.top-left {
  top: -16px;
  left: -16px;
  cursor: nwse-resize;
}
.resize-container.top-right {
  top: -16px;
  right: -16px;
  cursor: nesw-resize;
}
.resize-container.bottom-left {
  bottom: -16px;
  left: -16px;
  cursor: nesw-resize;
}
.resize-container.bottom-right {
  bottom: -16px;
  right: -16px;
  cursor: nwse-resize;
}

.resize-line.top,
.resize-line.bottom {
  height: 28px;
  width: 100%;
  background-color: var(--color-background-100);
}

.resize-line.left,
.resize-line.right {
  width: 28px;
  height: 100%;
  background-color: var(--color-background-100);
}

.resize-line.top {
  top: -12px;
  left: calc(-1 * var(--border-left, 2px));
  width: calc(100% + var(--border-horizontal, 4px));
  border-radius: var(--rounded-md) var(--rounded-md) 0 0;
  transform: translateY(28px);
}

.resize-line.bottom {
  bottom: -12px;
  left: calc(-1 * var(--border-left, 2px));
  width: calc(100% + var(--border-horizontal, 4px));
  border-radius: 0 0 var(--rounded-md) var(--rounded-md);
  transform: translateY(-28px);
}

.resize-line.left {
  top: calc(-1 * var(--border-top, 2px));
  left: -12px;
  height: calc(100% + var(--border-vertical, 4px));
  border-radius: var(--rounded-md) 0 0 var(--rounded-md);
  transform: translateX(28px);
}

.resize-line.right {
  top: calc(-1 * var(--border-top, 2px));
  right: -12px;
  height: calc(100% + var(--border-vertical, 4px));
  border-radius: 0 var(--rounded-md) var(--rounded-md) 0;
  transform: translateX(-28px);
}

.resize-container.right:hover ~ .resize-line.right,
.resize-container.left:hover ~ .resize-line.left,
.resize-line.right.dragging,
.resize-line.left.dragging {
  transform: translateX(0);
}

.resize-container.bottom:hover ~ .resize-line.bottom,
.resize-container.top:hover ~ .resize-line.top,
.resize-line.bottom.dragging,
.resize-line.top.dragging {
  transform: translateY(0);
}

/* make sure that we don't show multiple handles at once
 * we should only ever show the currently resizing handle
 * regardless of hover state 
 */
.resize-container.no-hover.right:hover ~ .resize-line.right {
  transform: translateX(-28px);
}
.resize-container.no-hover.left:hover ~ .resize-line.left {
  transform: translateX(28px);
}
.resize-container.no-hover.bottom:hover ~ .resize-line.bottom {
  transform: translateY(-28px);
}
.resize-container.no-hover.top:hover ~ .resize-line.top {
  transform: translateY(28px);
}
`, "",{"version":3,"sources":["webpack://./src/next-devtools/dev-overlay/components/devtools-panel/resize/resize-handle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,uEAAuE;EACvE,4DAA4D;EAC5D,uDAAuD;EACvD,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA,mIAAmI;AACnI;EACE,0DAA0D,EAAE,8BAA8B;AAC5F;;AAEA;;EAEE,MAAM;EACN,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA,oDAAoD;;AAEpD;;EAEE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC,iDAAiD;EACjD,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,iDAAiD;EACjD,sDAAsD;EACtD,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,gDAAgD;EAChD,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,gDAAgD;EAChD,sDAAsD;EACtD,4BAA4B;AAC9B;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;EAGE;AACF;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".resize-container {\n  position: absolute;\n  /* todo: better z index */\n  z-index: 10;\n  /* todo: is this needed */\n  background: transparent;\n}\n\n.resize-line {\n  position: absolute;\n  /* todo smarter z index */\n  z-index: -1;\n  pointer-events: none;\n  /* a normal exit animation curve- at this point the exit animation is */\n  /* immediately responsive so we don't need a bespoke curve */\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  /* todo: better var? */\n  border: 1px solid var(--color-gray-100);\n}\n\n/* start really fast because we start super hidden initially behind the panel, otherwise feels like an unintended animation delay */\n.resize-container:hover ~ .resize-line {\n  transition: transform 0.2s cubic-bezier(0.05, 0.9, 0.2, 1); /* Fast start for animate in */\n}\n\n.resize-container.right,\n.resize-container.left {\n  top: 0;\n  height: 100%;\n  width: 25px;\n  cursor: ew-resize;\n}\n\n/* todo: don't hard code all these values/use vars */\n\n.resize-container.bottom,\n.resize-container.top {\n  left: 0;\n  width: 100%;\n  height: 25px;\n  cursor: ns-resize;\n}\n\n.resize-container.top {\n  top: -12px;\n}\n.resize-container.bottom {\n  bottom: -12px;\n}\n.resize-container.left {\n  left: -12px;\n}\n.resize-container.right {\n  right: -12px;\n}\n\n.resize-container.top-left,\n.resize-container.top-right,\n.resize-container.bottom-left,\n.resize-container.bottom-right {\n  width: 32px;\n  height: 32px;\n  z-index: 15;\n}\n\n.resize-container.top-left {\n  top: -16px;\n  left: -16px;\n  cursor: nwse-resize;\n}\n.resize-container.top-right {\n  top: -16px;\n  right: -16px;\n  cursor: nesw-resize;\n}\n.resize-container.bottom-left {\n  bottom: -16px;\n  left: -16px;\n  cursor: nesw-resize;\n}\n.resize-container.bottom-right {\n  bottom: -16px;\n  right: -16px;\n  cursor: nwse-resize;\n}\n\n.resize-line.top,\n.resize-line.bottom {\n  height: 28px;\n  width: 100%;\n  background-color: var(--color-background-100);\n}\n\n.resize-line.left,\n.resize-line.right {\n  width: 28px;\n  height: 100%;\n  background-color: var(--color-background-100);\n}\n\n.resize-line.top {\n  top: -12px;\n  left: calc(-1 * var(--border-left, 2px));\n  width: calc(100% + var(--border-horizontal, 4px));\n  border-radius: var(--rounded-md) var(--rounded-md) 0 0;\n  transform: translateY(28px);\n}\n\n.resize-line.bottom {\n  bottom: -12px;\n  left: calc(-1 * var(--border-left, 2px));\n  width: calc(100% + var(--border-horizontal, 4px));\n  border-radius: 0 0 var(--rounded-md) var(--rounded-md);\n  transform: translateY(-28px);\n}\n\n.resize-line.left {\n  top: calc(-1 * var(--border-top, 2px));\n  left: -12px;\n  height: calc(100% + var(--border-vertical, 4px));\n  border-radius: var(--rounded-md) 0 0 var(--rounded-md);\n  transform: translateX(28px);\n}\n\n.resize-line.right {\n  top: calc(-1 * var(--border-top, 2px));\n  right: -12px;\n  height: calc(100% + var(--border-vertical, 4px));\n  border-radius: 0 var(--rounded-md) var(--rounded-md) 0;\n  transform: translateX(-28px);\n}\n\n.resize-container.right:hover ~ .resize-line.right,\n.resize-container.left:hover ~ .resize-line.left,\n.resize-line.right.dragging,\n.resize-line.left.dragging {\n  transform: translateX(0);\n}\n\n.resize-container.bottom:hover ~ .resize-line.bottom,\n.resize-container.top:hover ~ .resize-line.top,\n.resize-line.bottom.dragging,\n.resize-line.top.dragging {\n  transform: translateY(0);\n}\n\n/* make sure that we don't show multiple handles at once\n * we should only ever show the currently resizing handle\n * regardless of hover state \n */\n.resize-container.no-hover.right:hover ~ .resize-line.right {\n  transform: translateX(-28px);\n}\n.resize-container.no-hover.left:hover ~ .resize-line.left {\n  transform: translateX(28px);\n}\n.resize-container.no-hover.bottom:hover ~ .resize-line.bottom {\n  transform: translateY(-28px);\n}\n.resize-container.no-hover.top:hover ~ .resize-line.top {\n  transform: translateY(28px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
